import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'

import News from './components/news'

import NewsBack1 from './icons/cr_logo-1.webp'
import NewsBack2 from './icons/coincodecap_logo-3.webp'
import NewsBack3 from './icons/bitcourier-transparent.png'
import NewsBack4 from './icons/crypto-wisser.webp'
import NewsBack5 from './icons/cryptogeek.svg'
import NewsBack6 from './icons/hackernoon.webp'

import styles from './styles.module.scss'

export default function PressAboutUs() {
  const { t } = useTranslation()
  const amountOnMobile = 3

  const news = [
    {
      source: 'cryptowisser.com',
      link: 'https://www.cryptowisser.com/pr-how-can-i-profit-from-hodling-my-bitcoin/',
      date: 'Jan 8, 2020',
      img: NewsBack4,
      text:
        'The whole process takes 10 minutes and doesn’t require any credit checks — simply show your Bitcoin and get the money.',
    },
    {
      source: 'cryptogeek.info',
      link: 'https://cryptogeek.info/en/tools/coinrabbit',
      date: 'Dec 29, 2020',
      img: NewsBack5,
      text:
        'It has one of the smallest APR rates (5%) and a special monitoring system for every loan status tracking. ' +
        'Users can borrow crypto loans for unlimited time periods.',
    },
    {
      source: 'hackernoon.com',
      link: 'https://hackernoon.com/crypto-loan-services-enable-you-to-profit-off-of-hodling-bitcoin-943i34bn',
      date: 'Dec 25, 2020',
      img: NewsBack6,
      text:
        'You get your loan for however long you want, and you only pay the interest when you decide to take your Bitcoin back.',
    },
    {
      source: 'crypto-reporter.com',
      link:
        'https://www.crypto-reporter.com/press-releases/' +
        'how-to-make-the-most-of-your-crypto-without-spending-it-14443/',
      date: 'Nov 21, 2020',
      img: NewsBack1,
      text:
        'Unlimited loan periods. Why give a week, a month, or a year as our competitors? <br />' +
        'Take your time and repay the loan whenever you want!',
    },
    {
      source: 'blog.coincodecap.com',
      link: 'https://blog.coincodecap.com/coinrabbit-review',
      date: 'Nov 23, 2020',
      img: NewsBack2,
      text:
        'CoinRabbit only takes 5% interest yearly compared to 8-10% in the other services. <br />' +
        'Start with 30 USDT for ETH as collateral, and with 80 USDT for BTC.',
    },
    {
      source: 'bitcourier.co.uk',
      link: 'https://bitcourier.co.uk/blog/coinrabbit-review',
      date: 'Dec 3, 2020',
      img: NewsBack3,
      text:
        'CoinRabbit features a system that safeguard users’ ' +
        'collateral from liquidation. For instance, as you near a margin call, ' +
        'you have the option to manually increase your deposit or set up automatic top-ups to ensure your position remains secure.',
    },
  ]
  return (
    <div className={cn('container', styles.container)}>
      <h2 className={styles.title}>{t('press_coverage')}</h2>
      <div className={styles.subTitle}>{t('media_reviews')}</div>
      <div className={styles.news}>
        {news.map((data, index) => {
          return (
            <div
              key={index}
              className={cn(styles.newsItem, {
                [styles.newsItemToggleDisplay]: index >= amountOnMobile,
              })}
            >
              <News data={data} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
